import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { FormContextProvider, DisplaySpinnerContext } from "../../../context/ContextIndex";
import { AppForm, DynamicFormContainer, notifyToast, ToastType, TabPanel } from "../../../components";
import { getMarketSectorDefaultValue, getMarketSectorSchema } from "./Schema";
import { selectSessionConfig } from "../../../store/store-selector";
import { saveMarketSector } from "../api-handler/api-handler";
import AppFormRootContainer from "../../../components/app-components/app-form-root-container/AppFormRootContainer";

const CreateMarketSectorForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const EditMarketSectorId = searchParams.get("SectorId");
  const spinnerCtx = useContext(DisplaySpinnerContext);
  const settingsConfig = useSelector(selectSessionConfig);
  const navigationData = location.state;

  const [formdata, setFormdata] = useState({
    schema: getMarketSectorSchema(),
    appformdata: null,
  });

  const defaultValue = getMarketSectorDefaultValue();

  const handleCancel = () => {
    try {
      navigate("/marketsectorlist");
    } catch (err) {
      alert(err);
    }
  };

  const onSectorSubmit = async (data, formhandler) => {
    console.log("onSectorSubmit");
    const { reset, clearErrors } = formhandler;
    try {
      clearErrors();
      spinnerCtx.setLoadingIndicator(true);
      const status = await saveMarketSector(data, {
        EditMarketSectorId,
        settingsConfig,
        formdata: formdata.appformdata,
      });

      if (status?.responseStatus === 200) {
        notifyToast("Sent for Approval", ToastType.SUCCESS);
        handleCancel();
      } else {
        notifyToast(status.errorMessage ? status.errorMessage : "Market Sector creation failed", ToastType.ERROR);
        spinnerCtx.setLoadingIndicator(false);
      }
      if (status?.error) {
        reset(
          { ...data },
          {
            keepValues: true,
            keepSubmitCount: false,
            keepDirty: true,
            keepTouched: true,
          }
        );
      }
    } catch (err) {
      reset(
        { ...data },
        {
          keepValues: true,
          keepSubmitCount: false,
          keepDirty: true,
          keepTouched: true,
        }
      );
      alert(err);
    }
  };

  useEffect(() => {
    const setFormSchema = () => {
      try {

        let _formData = navigationData ? { ...navigationData } : null;

        if (_formData) {
          setFormdata((prevstate) => ({
            ...prevstate,
            schema: getMarketSectorSchema(),
            appformdata: getMarketSectorDefaultValue(_formData),
          }));
        } else {
          setFormdata((prevstate) => ({
            ...prevstate,
            schema: getMarketSectorSchema(),
          }));
        }

      } catch (err) {
        alert(err);
      } finally {
        spinnerCtx.setLoadingIndicator(false);
      }
    };

    spinnerCtx.setLoadingIndicator(true);
    setFormSchema();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppFormRootContainer>
      <TabPanel
        tabs={[
          {
            icon: "",
            label: t("navigationMenu.marketSector"),
            children: (
              <FormContextProvider schema={formdata.schema} defaultValues={defaultValue} appformdata={formdata.appformdata}>
                <AppForm onSubmit={onSectorSubmit}>
                  <DynamicFormContainer
                    header={EditMarketSectorId ? t("createMarketSector.editMarketSector") : t("createMarketSector.header")}
                    onCancel={handleCancel}
                  />
                </AppForm>
              </FormContextProvider>
            ),
          },
        ]}
        selectedTab="0"
        onTabChange={() => { }}
      />
    </AppFormRootContainer>
  );
};

export default CreateMarketSectorForm;
